<template>
  <div>
    <!-- 搜索区 -->
    <search-component @handleQueryData="handelSearch" @handleFilterData="handleFilter" />
    <add-btn v-hasPermi="['cont:saleContract:add']" @add="handleAddContract()" />
    <!-- 合同列表区 start -->
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" v-hasPermi="['cont:saleContract:list']" @load="handleContract" v-if="list.length > 0">
      <total-component :totalValue="total" />
      <van-cell v-for="(item,index) in list" :key="index" @click="toContractDetails(item)">
        <div class="flex-c-center" v-if="item">
          <div>
            <div class="custName-wrap">
              <div class="custName">
                {{ item.contractName }}
              </div>
            </div>
            <div>
              <van-tag color="#ccc" style="margin-right: 10px" plain type="primary" v-if="item.industryName">{{ item.industryName}}</van-tag>
              <van-tag color="#ccc" style="margin-right: 10px" plain type="primary" v-if="item.contractStatus">{{ contractStatusFormat2(item.contractStatus) }}</van-tag>
              <van-tag color="#ccc" style="margin-right: 10px" plain type="primary" v-if="item.payMode">{{ payModeFormat2(item.payMode) }}</van-tag>
            </div>
            <div>
              <van-tag color="#ccc" style="margin-right: 10px" plain type="primary" v-if="item.contractMoney">合同金额：{{ item.contractMoney }}</van-tag>
              <van-tag color="#ccc" style="margin-right: 10px" plain type="primary" v-if="item.signTime">签约日期：{{ item.signTime | timeFormat }}</van-tag>
            </div>
          </div>
          <van-icon name="arrow" size="16" class="arrow-color" @click="toContractDetails(item)" />
        </div>
      </van-cell>
    </van-list>
    <empty-component v-if="isEmpty" />
    <!-- 合同列表区 end -->
    
    <!--客户搜索-->
    <search-pop :show.sync="showFilterPop" @handlequery="handleFqueryFilter" />

    <dialog-contract :show='add_show' :contractType='6' @handleAddContractCancel='handleAddContractCancel' @beforeClose='addContractBeforeClose'></dialog-contract>
  </div>
</template>
<script>
import moment from "moment";
import { listContract, getContract, delContract, addContract, updateContract} from "@/api/cont/salecontract";
import { ucloudUpFileToContract } from "@/api/system/common";
import { getDicts } from "@/api/system/dict/data";
import SearchComponent from "@/components/common/Search";
import EmptyComponent from "@/components/common/Empty";
import TotalComponent from "@/components/common/Total";
import SearchPop from '../components/contract/SearchPop.vue'
import DialogContract from '../components/DialogContract.vue'
import AddBtn from "@/components/common/AddBtn";
export default {
  components: {
    SearchComponent,
    EmptyComponent,
    TotalComponent,
    SearchPop,
    AddBtn,
    DialogContract
  },
  filters: {
    timeFormat(val) {
      return moment(val).format("YYYY-MM-DD");
    },
  },
  data() {
    return {
      isEmpty: false,
      add_show: false,
      picker: {
        visible: false,
        title: "",
        columns: [],
        formKey: "",
      },
      loading: false,
      finished: false,
      noConLoading: false,
      noConFinished: false,
      failConLoading: false,
      failConFinished: false,
      otherConLoading: false,
      otherConFinished: false,
      showFilterPop: false,
      fileList: [],
      fileList1: [],
      fileList2: [],
      list: [],
      total: 0,
      noList: [],
      failList: [],
      otherList: [],
      type: "add",
      show: false,
      searchParams: {
        visible: false,
        contractType: "6",
      },
      searchValue: "",
      custList: [],
      // 客户等级
      custLevelOptions: [],
      // 地区树选项
      areaOptions: [],
      // 行业树选项
      industryOptions: [],
      // 客户类型字典
      custTypeOptions: this.$store.state.dictOptions.crmCustType || [],
      // 提单状态
      boStatusOptions: this.$store.state.dictOptions.custBoStatus || [],
      // 释放类型
      releaseModeOptions: [],
      // 客户来源字典
      custSourceOptions: this.$store.state.dictOptions.custSource || [],
      //投放类型列表
      launchTypeOptions: this.$store.state.dictOptions.custOrderLaunchType || [],
      //产品类型列表
      businessTypeOptions: this.$store.state.dictOptions.contractBusinessType || [],
      // 合同状态
      contractStatusOptions: this.$store.state.dictOptions.contractStatus || [],
      // 合同类型
      contractTypeOptions: this.$store.state.dictOptions.contractType || [],
      // 支付方式
      payModeOptions: this.$store.state.dictOptions.payMode || [],
      showStartCalendar: false,
      showEndCalendar: false,
      showSignCalendar: false,
      minDate: new Date(2010, 0, 1),
      minDateStart: new Date(2010, 0, 1),
      active: 0,
      // 列表
      activeName: "active_nocontract",
      // form: {
      //   contractId: null,
      //   custOrderId: null,
      //   contractNum: null,
      //   contractName: null,
      //   custId: null,
      //   custName: null,
      //   contractSource: null,
      //   contractType: "6",
      //   contractStatus: null,
      //   payMode: null,
      //   hkStatus: null,
      //   verifyStatus: null,
      //   contractMoney: null,
      //   startTime: null,
      //   endTime: null,
      //   custSignedUser: null,
      //   mySignedUser: null,
      //   signTime: null,
      //   contractFile: null,
      //   annexOne: null,
      //   annexTwo: null,
      //   content: null,
      //   readerCount: null,
      //   createBy: null,
      //   createTime: null,
      //   updateBy: null,
      //   updateTime: null,
      //   status: "0",
      //   delFlag: null,
      //   remark: null,
      //   contractImg: null,
      // },
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        contractType: "6"
      },
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      //修改主体框架标题
      document.title = "CONT-2022合同信息";
     
      //释放类型
      getDicts("release_mode").then((response) => {
        this.releaseModeOptions = response.data;
      });
      await this.handleContract();
    },
    // 提单状态
    boStatusFormat2(boStatus) {
      return this.selectDictLabel(this.boStatusOptions, boStatus);
    },
    // 产品类型
    businessTypeFormat2(businessType) {
      return this.selectDictLabel(this.businessTypeOptions, businessType);
    },
    // 投放类型
    launchTypeFormat2(launchType) {
      return this.selectDictLabel(this.launchTypeOptions, launchType);
    },
    contractTypeFormat2(contractType) {
      return this.selectDictLabel(this.contractTypeOptions, contractType);
    },
    contractStatusFormat2(contractStatus) {
      return this.selectDictLabel(this.contractStatusOptions, contractStatus);
    },
    //合同类型字典翻译
    contractTypeFormat(row, column) {
      return this.selectDictLabel(this.contractTypeOptions, row.contractType);
    },
    //合同状态字典翻译
    contractStatusFormat(row, column) {
      return this.selectDictLabel(
        this.contractStatusOptions,
        row.contractStatus
      );
    },
    //支付方式字典翻译
    payModeFormat2(payMode) {
      return this.selectDictLabel(this.payModeOptions, payMode);
    },
    payModeFormat(row, column) {
      return this.selectDictLabel(this.payModeOptions, row.payMode);
    },
    formatDate(date) {
      // 时间格式化 2019-09-08
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      return year + "-" + month + "-" + day;
    },
    onStartCalendarConfirm(data) {
      this.form.startTime = this.formatDate(data);
      this.showStartCalendar = false;
      this.minDateStart = data
    },
    onEndCalendarConfirm(data) {
      this.form.endTime = this.formatDate(data);
      this.showEndCalendar = false;
    },
    onSignCalendarConfirm(data) {
      this.form.signTime = this.formatDate(data);
      this.showSignCalendar = false;
    },
    // 搜索子组件传递过来的搜索关键字
    handelSearch(data) {
      this.resetQuery()
      this.queryParams.contractName = this.searchValue = data;
      this.queryContractList()
    },
    // 过滤子组件传递过来的搜索对象
    handleFqueryFilter(data) {
      let query = this.queryParams;
      this.queryParams = { ...query, ...data }
      this.queryContractList()
    },
    // 接收子组件的filter事件
    handleFilter() {
      this.showFilterPop = true
    },
    queryContractList() {
      this.list = [];
      this.queryParams.pageNum = 1
      this.handleContract();
    },
    toContractDetails(item) {
      this.$router.push({
        name: "salecontractdetail",
        query: {
          id: item.contractId,
          verifyStatus: item.verifyStatus,
          contractSource: item.contractSource,
        },
      });
    },
    handleAddContract() {
      this.add_show = true;
    },
    handleAddContractCancel() {
      this.add_show = false;
    },
    //添加合同
    addContractBeforeClose(form) {
      let _this = this;
      // if (type === "confirm") {
      //   try {
          // await this.$refs["form"].validate();
          addContract(form).then((response) => {
            if(response.code == 200){
              Toast.success("添加成功");
              _this.add_show = false;
            }else{
              Toast.fail("添加失败:"+response.msg);
            }
          });
          setTimeout(() => {
            _this.queryContractList();
          },500)
          // done();
        // } catch (err) {
        //   return done(false);
        // }
      //   return done(false);
      // } else {
      //   return done();
      // }
    },
    pickerConfirm(value, index) {
      if (this.picker.formKey === "contractType") {
        this.form.contractType = this.contractTypeOptions[index].dictValue;
        this.form.contractTypeName = this.contractTypeOptions[index].dictLabel;
      }
      if (this.picker.formKey === "contractStatus") {
        this.form.contractStatus = this.contractStatusOptions[index].dictValue;
        this.form.contractStatusName =
          this.contractStatusOptions[index].dictLabel;
      }
      if (this.picker.formKey === "payMode") {
        this.form.payMode = this.payModeOptions[index].dictValue;
        this.form.payModeName = this.payModeOptions[index].dictLabel;
      }
      this.picker.visible = false;
    },
    pickerChange() { },
    // 获取合同数据
    getContractData(contractId) {
      getContract(contractId).then(response => {
        console.log(response.data);
        this.value1 = response.data.mySignedUser;
        this.form = response.data;

        if (this.form.contractImg != null && this.form.contractImg.length > 0) {
          let contractImgs = this.form.contractImg.split(",")
          contractImgs.forEach(element => {
            this.pictureList.push({
              url: element
            })
          });
        }
        if (this.form.isAdvances != null) {
          this.isAdvanceShow = this.form.isAdvances == '1'
        }
        this.open = true;
        this.title = "修改合同管理";
      });
    },
    /** 详情按钮操作 */
    contractInfo(row) {
      this.reset();
      const contractId = row.contractId || this.ids
      getContract(contractId).then(response => {
        this.form = response.data;
        this.info.open = true;
        this.info.title = "合同管理详情";
      });
    },
    async handleContract() {
      this.loading = true;
      const res = await listContract(this.queryParams);
      if (res.code === 200) {
        if (res.rows.length === 0) {
          this.isEmpty = true
        }
        this.list = this.list.concat(res.rows);
        this.total = res.total
        this.queryParams.pageNum += 1;
        this.loading = false;
        this.finished = this.list.length >= res.total;
        this.showFilterPop = false
      }
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const contractIds = row.contractId || this.ids;
      this.$confirm('是否确认删除合同管理编号为"' + contractIds + '"的数据项?', "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return delContract(contractIds);
      }).then(() => {
        this.getList();
        Toast.success("删除成功");
      })
    },
    pickerCancel() {
      this.picker.visible = false;
    },
    // 返回布尔值
    beforeRead(file) {
      if (
        file.type !== "image/jpeg" &&
        file.type !== "image/png" &&
        file.type !== "image/jpg"
      ) {
        Toast("请上传 jpg 、jpeg、png 格式图片");
        return false;
      }
      return true;
    },
    uploadContractPictureFiles(file) {
      console.log(file);
      const _file = file.file;
      // 通过 FormData 对象上传文件
      var formData = new FormData();
      formData.append("file", _file);

      ucloudUpFileToContract(formData)
        .then((res) => {
          console.log("_RequestUploads_", res);
          if (res.code === 200) {
            // this.form.contractImg = res.url;
            let picture = this.form.contractImg;
            if (picture != null && picture.length > 0) {
              picture += "," + res.url;
            } else {
              picture = res.url;
            }
            this.form.contractImg = picture;
            let payCaptures = this.form.contractImg.split(",");
            this.pictureList = [];
            payCaptures.forEach((element) => {
              this.pictureList.push({
                url: element,
              });
            });
            Toast.success(res.msg);
          } else {
            Toast.fail("res.msg");
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    uploadContractFiles(file) {
      const _file = file.file;
      // 通过 FormData 对象上传文件
      var formData = new FormData();
      formData.append("file", _file);

      ucloudUpFileToContract(formData)
        .then((res) => {
          console.log("_RequestUploads_", res);
          if (res.code === 200) {
            this.form.contractFile = res.url;
            Toast.success(res.msg);
          } else {
            Toast.fail("res.msg");
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    uploadContractFiles1(file) {
      const _file = file.file;
      // 通过 FormData 对象上传文件
      var formData = new FormData();
      formData.append("file", _file);
      ucloudUpFileToContract(formData)
        .then((res) => {
          console.log("_RequestUploads_", res);
          if (res.code === 200) {
            this.form.annexOne = res.url;
            Toast.success(res.msg);
          } else {
            Toast.fail("res.msg");
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    uploadContractFiles2(file) {
      const _file = file.file;
      // 通过 FormData 对象上传文件
      var formData = new FormData();
      formData.append("file", _file);

      ucloudUpFileToContract(formData)
        .then((res) => {
          console.log("_RequestUploads_", res);
          if (res.code === 200) {
            this.form.annexTwo = res.url;
            Toast.success(res.msg);
          } else {
            Toast.fail("res.msg");
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    showPicker(type) {
      this.picker.formKey = type
      if (type === 'custLevelId') {
        this.picker.columns = this.custLevelOptions.map(ele => ele.levelName)
      }
      if (type === 'custSource') {
        this.picker.columns = this.custSourceOptions.map(ele => ele.dictLabel)
      }
      if (type === 'custType') {
        this.picker.columns = this.custTypeOptions.map(ele => ele.dictLabel)
      }
      if (type === 'businessTypeId') {
        this.picker.columns = this.businessTypeOptions.map(ele => this.businessNormalizer(ele))
      }
      if (type === 'industryCode') {
        this.picker.columns = this.industryOptions.map(ele => this.industryNormalizer(ele))
      }
      if (type === 'areaId') {
        this.picker.columns = this.areaOptions.map(ele => this.areaNormalizer(ele))
      }
      //回访联系类型    
      if (type === 'visitType') {
        this.picker.columns = this.custVisitTypeOptions.map(ele => ele.dictLabel);
      }
      //回访联系人
      if (type === 'contactId') {
        this.picker.columns = this.custContactOptions.map(ele => ele.contactName);
      }
      if (type === 'ideType') {
        this.picker.columns = this.ideTypeOptions.map(ele => ele.dictLabel);
      }
      if (type === 'roleRelation') {
        this.picker.columns = this.roleRelationOptions.map(ele => ele.dictLabel)
      }
      if (type === 'intimacy') {
        this.picker.columns = this.intimacyOptions.map(ele => ele.dictLabel)
      }
      if (type === "contractType") {
        this.picker.columns = this.contractTypeOptions.map(
          (ele) => ele.dictLabel
        );
      }
      if (type === "contractStatus") {
        this.picker.columns = this.contractStatusOptions.map(
          (ele) => ele.dictLabel
        );
      }
      if (type === "payMode") {
        this.picker.columns = this.payModeOptions.map((ele) => ele.dictLabel);
      }
      this.picker.visible = true
    },
    handleContractRemove(file) {
      let picture = this.form.contractImg;
      if (picture.indexOf(file.url) == 0) {
        if (picture.indexOf(",") == -1) {
          picture = null;
        } else {
          picture = picture.replace(file.url + ",", "");
        }
      } else {
        picture = picture.replace("," + file.url, "");
      }
      this.form.contractImg = picture;
      this.pictureList = [];
      if (this.form.contractImg != null && this.form.contractImg.length > 0) {
        let payCaptures = this.form.payCapture.split(",");
        payCaptures.forEach((element) => {
          this.pictureList.push({
            url: element,
          });
        });
      }
      this.deleteFileList.push(file.url);
      console.log(this.deleteFileList);
    },
    resetQuery() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        custOrderId: null,
        contractNum: null,
        contractName: null,
        custId: null,
        custName: null,
        contractSource: null,
        contractType: '6',
        contractStatus: null,
        payMode: null,
        hkStatus: null,
        verifyStatus: null,
        contractMoney: null,
        startTime: null,
        endTime: null,
        custSignedUser: null,
        mySignedUser: null,
        signTime: null,
        contractFile: null,
        annexOne: null,
        annexTwo: null,
        content: null,
        readerCount: null,
        status: null,
      };
    },
    reset() {
      this.form = {
        contractId: null,
        custOrderId: null,
        contractNum: null,
        contractName: null,
        custId: null,
        custName: null,
        contractSource: null,
        contractType: null,
        contractStatus: null,
        payMode: null,
        contractTypeName: null,
        contractStatusName: null,
        payModeName: null,
        hkStatus: null,
        verifyStatus: null,
        contractMoney: null,
        allReturnedMoney: null,
        noReturnedMoney: null,
        startTime: null,
        endTime: null,
        custSignedUser: null,
        mySignedUser: null,
        signTime: null,
        contractFile: null,
        annexOne: null,
        annexTwo: null,
        content: null,
        readerCount: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        status: "0",
        delFlag: null,
        remark: null,
      };
    },
  },
};
</script>
<style lang="less" scoped>
.editClue /deep/.van-dialog__content {
  height: 80%;
}
</style>